/*
 * Lumera üyelik pop-up'ı (sections/lum-newsletter-popup.liquid).
 * Zamanlama: ilk girişten `data-delay` sn sonra açılır; gösterildikten sonra `data-frequency` saat geçmeden tekrar açılmaz.
 * Abone olan tarayıcıya bir daha kendiliğinden açılmaz. "#lum-uye-ol" bağlantıları her zaman açar.
 * Kayıt fetch ile gönderilir; Shopify bot doğrulaması (/challenge) isterse form normal yolla gönderilir
 * ve dönüşte kod ekranı açılır.
 */
(() => {
  const dialog = document.querySelector('[data-lum-pop]');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';

  const KEY_SEEN = 'lum-pop:seen';
  const KEY_SUBSCRIBED = 'lum-pop:subscribed';
  const KEY_PENDING = 'lum-pop:pending';
  const HASH = '#lum-uye-ol';

  const safe = (storage) => ({
    get(key) {
      try {
        return storage().getItem(key);
      } catch {
        return null;
      }
    },
    set(key, value) {
      try {
        storage().setItem(key, value);
      } catch {}
    },
    remove(key) {
      try {
        storage().removeItem(key);
      } catch {}
    },
  });
  const local = safe(() => window.localStorage);
  const session = safe(() => window.sessionStorage);

  const designMode = dialog.hasAttribute('data-design-mode');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const delayMs = Math.max(0, Number(dialog.dataset.delay) || 0) * 1000;
  const frequencyMs = Math.max(1, Number(dialog.dataset.frequency) || 12) * 3600 * 1000;

  const form = dialog.querySelector('[data-lum-pop-form]');
  const email = form?.querySelector('input[type="email"]');
  const submit = dialog.querySelector('[data-lum-pop-submit]');
  const error = dialog.querySelector('.lum-pop__error');
  const done = dialog.querySelector('[data-lum-pop-done]');
  const copyButton = dialog.querySelector('[data-lum-pop-copy]');
  const code = dialog.querySelector('[data-lum-pop-code]')?.textContent.trim() ?? '';

  let closeTimer;

  function open(state = 'form') {
    clearTimeout(closeTimer);
    dialog.dataset.state = state;
    if (!dialog.open) dialog.showModal();
    requestAnimationFrame(() => requestAnimationFrame(() => dialog.setAttribute('data-visible', '')));
    if (!designMode) local.set(KEY_SEEN, String(Date.now()));
    if (state === 'done') done?.focus({ preventScroll: true });
  }

  function close() {
    if (!dialog.open) return;
    dialog.removeAttribute('data-visible');
    closeTimer = setTimeout(() => dialog.close(), reduceMotion.matches ? 200 : 340);
  }

  function showDone() {
    local.set(KEY_SUBSCRIBED, '1');
    dialog.dataset.state = 'done';
    done?.focus({ preventScroll: true });
  }

  function setError(visible) {
    if (error) error.hidden = !visible;
    email?.setAttribute('aria-invalid', String(visible));
  }

  // Sayfanın başka bir penceresi (sepet, menü) açıkken araya girme; kısa aralıklarla tekrar dene.
  function openWhenFree(attempt = 0) {
    const busy = document.querySelector('dialog[open]:not([data-lum-pop])');
    if (busy && attempt < 5) {
      setTimeout(() => openWhenFree(attempt + 1), 4000);
      return;
    }
    if (!busy) open('form');
  }

  function schedule() {
    if (local.get(KEY_SUBSCRIBED)) return;
    const lastSeen = Number(local.get(KEY_SEEN)) || 0;
    if (Date.now() - lastSeen < frequencyMs) return;
    setTimeout(openWhenFree, delayMs);
  }

  // Kapatma: X, "Hayır, teşekkürler", Esc ve pencere dışına tıklama
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog || event.target.closest('[data-lum-pop-close]')) close();
  });
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });

  // Duyuru çubuğu vb. bağlantılar
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link || !link.getAttribute('href').endsWith(HASH)) return;
    event.preventDefault();
    open(local.get(KEY_SUBSCRIBED) ? 'done' : 'form');
  });

  email?.addEventListener('input', () => setError(false));

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    setError(false);
    submit?.setAttribute('aria-busy', 'true');

    const fallback = () => {
      session.set(KEY_PENDING, '1');
      HTMLFormElement.prototype.submit.call(form);
    };

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
      });
      if (response.url.includes('/challenge')) return fallback();

      const html = await response.text();
      const page = new DOMParser().parseFromString(html, 'text/html');
      const result = page.querySelector('[data-lum-pop-result]')?.dataset.lumPopResult;

      if (result === 'success' || (!result && response.url.includes('customer_posted=true'))) {
        showDone();
      } else {
        setError(true);
        email?.focus();
      }
    } catch {
      fallback();
    } finally {
      submit?.removeAttribute('aria-busy');
    }
  });

  copyButton?.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      const range = document.createRange();
      range.selectNodeContents(dialog.querySelector('[data-lum-pop-code]'));
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
    }
    const label = copyButton.textContent;
    copyButton.textContent = copyButton.dataset.copiedLabel || label;
    setTimeout(() => (copyButton.textContent = label), 2400);
  });

  // Başlangıç
  if (designMode) {
    if (dialog.dataset.preview === 'true') open(dialog.dataset.previewState || 'form');
    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail.sectionId === dialog.dataset.sectionId) open(dialog.dataset.previewState || 'form');
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.detail.sectionId === dialog.dataset.sectionId) close();
    });
    return;
  }

  const posted = dialog.querySelector('[data-lum-pop-result]')?.dataset.lumPopResult === 'success';
  if (session.get(KEY_PENDING)) {
    session.remove(KEY_PENDING);
    if (posted) {
      local.set(KEY_SUBSCRIBED, '1');
      open('done');
      return;
    }
  }

  if (window.location.hash === HASH) {
    open(local.get(KEY_SUBSCRIBED) ? 'done' : 'form');
    return;
  }

  schedule();
})();
